import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PopupComponent } from './popup/popup.component';
import { ReceiptViewerServiceProxy, RvServerResponseDataDto, RvServerResponseItemsDto } from '@shared/service-proxies/service-proxies';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'kt-receipt-viewer',
  templateUrl: './receipt-viewer.component.html',
  styleUrls: ['./receipt-viewer.component.scss']
})
export class ReceiptViewerComponent implements OnInit {

  id: string | undefined; //Platom'dan gelen kayıdın Guid id bilgisini tutar.
  imageUrl: string;   //Görselin URL adresi bilgisini tutar.
  rotationAngle = 0;  //Görselin açı bilgisini tutar (Her butona basıldığında 90 derece döner)

  data = new BehaviorSubject<RvServerResponseDataDto>(null);  //json dosyasındaki verileri tutacak değişken
  items = new BehaviorSubject<RvServerResponseItemsDto[]>(null);


  constructor(private _route: ActivatedRoute,
    private dataService: ReceiptViewerServiceProxy,
    private dialogRef: MatDialog) {
      //Aşağıdaki kodlar URL üzerinden girilen id bilgisini yakalamak için _route.paramMap() kullanarak yakalar.
      this._route.paramMap.subscribe((params) => {
        this.id = params.get("id");
        console.log("id", this.id);
      });

      this.imageUrl = 'http://ikportal.ekomgroup.com:8080/Content/MasrafImages/20da0206-6c43-ef11-9341-005056012243/image.jpg';
     }

  ngOnInit() {
    try {
      this.dataService.getReceiptViewerResult(this.id)
      .subscribe((result: RvServerResponseDataDto) => {
        this.data.next(result);
        this.items.next(result.items);   
        console.log(this.data.value);
        console.log(this.items.value);     
      });
    }
    catch (error) {
      throw new alert(this.id + "ilgili kayıt yüklenirken bir sorun oluştu.");
    }
  }

  openRowUpdateWindow(rowData: any) {
    this.dialogRef.open(PopupComponent ,//Ilk parametre 
      { //Ikinci parametre
      data: rowData,
      width: '70%', 
      height: '300px', 
      maxWidth: '90vw', 
      maxHeight: '90vh', 
      autoFocus: false 
      }
    );  //Ilk parametrede dialog penceresinde açılacak component'i ikinci parametrede ise dialog config ayarları yer alır.
  }

  rotateImage() {
    this.rotationAngle = (this.rotationAngle + 90) % 360; //Görselin alacağı açıyı hesaplıyor.
  }
}
